import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { popup_alert } from "../../../popup_alert";
import Select from "react-select";
import { Col, Row, Button, Form, Placeholder } from "react-bootstrap";

import "react-toastify/dist/ReactToastify.css";
import "react-activity/dist/library.css";
import { loader } from "../../../loader";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import { toast } from "react-toastify";
import { getData } from "../../../axios/apiInstanceHelper";
import { ENDPOINT } from "../../../axios/apiConfig";
import { postData } from "../../../axios/apiHelper";


const CreateEditHighlight = () => {
  const editorRef = useRef();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [validationError, setValidationError] = useState({});
  const [posterImage, setPosterImage] = useState();
  const [posterImageUrl, setPosterImageUrl] = useState(
    "https://docintel.s3.eu-west-1.amazonaws.com/onesource_images/vid_1756383013540.png",
  );
  const [attachContent, setAttachContent] = useState(false);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [editorText, setEditorText] = useState("");
  const [contentOption, setContentOption] = useState();
  const [selectedContentOption, setSelectedContentOption] = useState();
  const [highlightData, setHighlightData] = useState();

  useEffect(() => {
    const fetchPrefilledData = async () => {
      try {
        const data = await getData(
          ENDPOINT.GET_HIGHLIGHTS + "/" + state?.id,
          {
            headers: {
              Auth: localStorage.getItem("decrypted_token"),
              frontendid: localStorage.getItem("user_id"),
              Token: localStorage.getItem("user_id"),
              created_by: localStorage.getItem("user_id"),
            },
          },
        );
        if (data?.status === 200) {
          const tempData = data?.data?.data;
          setHighlightData(tempData);
          setTitle(state?.heading ?? tempData.heading);
          setSubtitle(state?.sub_heading ?? tempData.sub_heading);
          setEditorText(tempData.content);
        setAttachContent(
            state?.previewData?.attach_content
              ? true
              : tempData.attach_content
                ? true
                : false
          );
         setPosterImageUrl(state?.image ?? tempData.image);
        }
      } catch (err) {
        console.log("error while library data : ", err);
        toast.error("Failed to get the highlight data");
      }
    };

    const getLibraryData = async () => {
      try {
        const data = await postData(
          ENDPOINT.LIBRARY,
          {
            selectValue:
              '["id","title","pdf_sub_title","pdf_file","pdf_thumb"]',
            type: "rest",
            analytics: 1,
          },
          {
            headers: {
              Auth: localStorage.getItem("decrypted_token"),
              Token: localStorage.getItem("user_id"),
            },
          },
        );
        if (data?.status === 200) {
          setContentOption(data?.data?.data?.library);
        }
      } catch (err) {
        console.log("error while library data : ", err);
        toast.error("Failed to get the attachable contents list");
      }
    };

    const fetchInitialData = async () => {
      loader("show");
      if (!contentOption) await getLibraryData();
      if (state?.type === "edit" || state?.type === "view") await fetchPrefilledData();
      loader("hide");
    };
    fetchInitialData();
  }, [state]);

  useEffect(() => {
    if (contentOption && highlightData) {
      const selectedOption = contentOption
        ?.filter((item) => item.id === highlightData?.attach_content)
        ?.map((item) => ({ label: item.title, value: item.id }))[0];
      console.log(selectedOption);
      setSelectedContentOption(selectedOption);
    }
  }, [contentOption, highlightData]);

  const handleSubmit = async () => {
    try {
      if (!title.trim()) {
        setValidationError({ title: "Please Enter the title" });
        return;
      } else setValidationError({});

      const state1 = {
        element: highlightData,
        image: posterImageUrl,
        attach_content: selectedContentOption ? "1" : "0",
        selectedContent:
          selectedContentOption &&
          contentOption.filter(
            (item) => item.id === selectedContentOption.value,
          )[0],
        heading: title,
        sub_heading: subtitle,
        content: editorRef?.current?.currentContent,
        type: state?.type,
      };
      console.log(state);
      navigate("/preview-highlight", {
        state: state1,
      });
    } catch (err) {
      console.log("error while create update highlight", err);
    }
  };

  const uploadImageToServer = async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file);

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        let tox = document.querySelector(
          "body > div.tox.tox-silver-sink.tox-tinymce-aux > div.tox-dialog-wrap > div.tox-dialog",
        );
        let tox1 = document.querySelector(
          "body > div.tox.tox-silver-sink.tox-tinymce-aux > div.tox-dialog-wrap > div.tox-dialog-wrap__backdrop",
        );
        let aux = document.querySelector(
          "body > div.tox.tox-silver-sink.tox-tinymce-aux > div > div",
        );
        xhr.upload.addEventListener("progress", (event) => {
          tox.style.opacity = 0;
          tox1.style.opacity = 0;
          aux.style.opacity = 0;
        });

        xhr.addEventListener("load", () => {
          if (xhr.status === 200) {
            try {
              const uploadedData = JSON.parse(xhr.responseText);
              const imageUrl = uploadedData.imageUrl;
              resolve(imageUrl);
            } catch (parseError) {
              console.error("Failed to parse response JSON:", parseError);
              reject(null);
            } finally {
              tox1.style.opacity = 1;
              tox.style.opacity = 1;
              aux.style.opacity = 1;
            }
          } else {
            console.error("Image upload failed");
            reject(null);
          }
        });

        xhr.addEventListener("error", (error) => {
          console.error("Image upload error:", error);
          reject(null);
        });

        xhr.open("POST", "https://onesource.informed.pro/api/upload-image");
        xhr.send(formData);
      });
    } catch (error) {
      console.error("Image upload error:", error);
      return null;
    }
  };

  const handleFileChange = async (e) => {
    try {
      loader("show");
      const file = e.target.files[0];
      if (file) setPosterImage(file);
      let fileName = file?.name?.split(".");
      fileName.pop();
      fileName.join(".");
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "image");
      formData.append("name", fileName?.join(".") || "highlight_image");

      const data = await axios.post(
        "https://infobackend.docintelhub.com/onesource/onesource-uploadaws",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("user_id"),
            Auth: localStorage.getItem("decrypted_token"),
          },
        },
      );
      if (data.status === 200) setPosterImageUrl(data?.data?.data);
    } catch (err) {
      console.log("error while uploading the file on aws", err);
      toast.error("Failed to upload the highlight poster. Please try again!!")
    } finally {
      loader("hide");
    }
  };

  return (
    <Col className="right-sidebar custom-change onesource-opition">
      <div className="custom-container">
        <>
          <div className="page-top-nav sticky">
            <div className="d-flex justify-content-between align-items-center w-100">
              <Row className="justify-content-end align-items-center w-100">
                <Col md={1}>
                  <div className="header-btn-left"></div>
                </Col>

                <Col md={9}>
                  <ul className="tabnav-link">
                    <li className="active active-main">
                      <a href="#">
                        {state?.type === "edit" ||state?.type === "view"
                          ? "Update your highlight"
                          : "Create your highlight"}
                      </a>
                    </li>
                    <li className="">
                      <a href="#">Preview your highlight</a>
                    </li>
                  </ul>
                </Col>

                <Col md={2}>
                  <div className="header-btn">
                    <Button
                      className="btn btn-primary btn-bordered move-draft"
                      onClick={() => navigate("/highlights")}
                    >
                      Cancel
                    </Button>
                    <button
                      type="submit"
                      className={"btn btn-primary "}
                      onClick={handleSubmit}
                    >
                      Next
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <form className="dynamic-form">
            <div className="form-field-wrapper d-flex highlight-media">
              <label htmlFor="image" className="form-label">
                Highlight cover
              </label>
              <div className="form-field-container">
                <div className="d-flex align-items-center  ">
                  <div className="img-added">
                    <img
                      src={
                        posterImage
                          ? URL.createObjectURL(posterImage)
                          : posterImageUrl
                      }
                      alt="Preview"
                      className="inserted"
                      style={{ width: "220px" }}
                    />
                  </div>
                  <div className="input-file-container">
                    <input
                      id="image"
                      type="file"
                      name="image"
                      className="input-file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    <label htmlFor="image-file" className="input-file-trigger">
                      Change Image
                    </label>
                    <br />
                    <span className="">
                      Recommended size:
                      <br />
                      width: 386px | Height: 220px
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="event-registration level-1">
              <div className="form-field-wrapper">
                <label htmlFor="acttachContent">Attach content?</label>
                <div className="form-field-container">
                  <div className="switch" style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                    <label className="switch-light">
                      <input
                        inline
                        label="Yes"
                        name="acttachContent"
                        type="checkbox"
                        checked={attachContent}
                        onChange={(e) => setAttachContent(e.target.checked)}
                      />
                      <span>
                        <span className="switch-btn active">
                          No
                        </span>
                        <span className="switch-btn ">
                          yes
                        </span>
                      </span>
                      <a className="btn"></a>
                    </label>
                  </div>
                </div>
              </div>
              {attachContent && (
                <div className="form-field-wrapper">
                  <label htmlFor="content_id" className="form-label"></label>
                  <div className="form-field-container select-field">
                  <Select
                    options={contentOption?.map((item) => ({
                      label: item?.title,
                      value: item?.id,
                    }))}
                    onChange={setSelectedContentOption}
                    isClearable
                    defaultValue=""
                    placeholder="Select content to attach"
                    value={selectedContentOption}
                  />
                </div>
                </div>
              )}
            </div>
            <div
              className={`form-field-wrapper is-required ${validationError.title && "has-error"}`}
            >
              <label htmlFor="heading" className="form-label">
                Highlight title
                <span className="required-asterisk">*</span>
              </label>
              <div className="form-field-container">
                <input
                  type="text"
                  id="heading"
                  className="form-control"
                  name="heading"
                  value={title}
                  onChange={(e) => setTitle(e?.target?.value)}
                />
                 {validationError.title && (
                <span class="form-error">Please enter the highlight title</span>
              )}
              </div>
            </div>
            <div className="form-field-wrapper">
              <label htmlFor="sub_heading" className="form-label">
                Highlight subtitle
              </label>
              <div className="form-field-container">
                <input
                  type="text"
                  id="sub_heading"
                  className="form-control"
                  name="sub_heading"
                  value={subtitle}
                  onChange={(e) => setSubtitle(e?.target?.value)}
                />
              </div>
            </div>
            <div className="form-field-wrapper">
              <div className="form-field-container">
                <div className="text-editor border rounded p-2 w-100 h-100">
                  <div className="text-editor">
                <Editor
                  apiKey="gpl"
                  tinymceScriptSrc={
                    window.location.origin + "/tinymce/tinymce.min.js"
                  } // Ensure this path is correct
                  ref={editorRef}
                  // onInit={(editor) => (editorRef.current = editor)}
                  initialValue={editorText}
                  init={{
                    height: "120px",
                    highlight_on_focus: false,
                    branding: false,
                    menubar: false,
                    font_css: [
                      "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap",
                    ],
                    font_family_formats:
                      "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Cormorant Upright=cormorant upright;Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Nunito=Nunito; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;Poppins=poppins; ",
                    plugins:
                      "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
                    toolbar:
                      "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample code | ltr rtl",
                    // content_style:"body { font-family:Roboto,Helvetica,Arial,sans-serif; font-size:12px;color:#0066be;cursor: text; } body p img{width:100%;} body p{color:#0066be; margin: 2px 0;}, body *{margin:2px 0;}",
                    automatic_uploads: true,
                    image_caption: true,
                    fontsize_formats:
                      "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 36px 48px 60px", // Optional: Customize font sizes
                    placeholder: Placeholder,
                    link_default_target: "_blank",
                    file_picker_types: "file image media",
                    file_picker_callback: function (callback, value, meta) {
                      const input = document.createElement("input");

                      if (meta.filetype === "media") {
                        input.setAttribute("type", "file");
                        input.setAttribute("accept", "video/*");

                        input.onchange = async () => {
                          const file = input.files[0];
                          if (file) {
                            let uploadedImageUrl;

                            try {
                              if (meta && meta.width && meta.height) {
                                uploadedImageUrl = await uploadImageToServer(
                                  file,
                                  meta.width,
                                  meta.height,
                                );
                              } else {
                                uploadedImageUrl =
                                  await uploadImageToServer(file);
                              }

                              if (uploadedImageUrl) {
                                callback(uploadedImageUrl, {
                                  width: 500,
                                  height: 500,
                                });
                              } else {
                                console.error("Failed to upload image");
                              }
                            } catch (error) {
                              console.error("Error uploading image:", error);
                            } finally {
                            }
                          }
                        };
                      } else {
                        input.setAttribute("type", "file");
                        input.setAttribute("accept", "image/*");

                        // Create a loading indicator element (e.g., a spinner)
                        const loadingIndicator = document.createElement("div");
                        loadingIndicator.className = "loading-indicator";
                        loadingIndicator.textContent = "Uploading..."; // You can use a spinner icon or any text you prefer

                        input.onchange = async () => {
                          document.body.appendChild(loadingIndicator); // Show loading indicator

                          const file = input.files[0];
                          if (file) {
                            let uploadedImageUrl;

                            try {
                              if (meta && meta.width && meta.height) {
                                uploadedImageUrl = await uploadImageToServer(
                                  file,
                                  meta.width,
                                  meta.height,
                                );
                              } else {
                                uploadedImageUrl =
                                  await uploadImageToServer(file);
                              }

                              if (uploadedImageUrl) {
                                callback(uploadedImageUrl, {
                                  width: 500,
                                  height: 500,
                                });
                                loader("hide");
                              } else {
                                console.error("Failed to upload image");
                              }
                            } catch (error) {
                              console.error("Error uploading image:", error);
                            } finally {
                              document.body.removeChild(loadingIndicator); // Hide loading indicator
                            }
                          }
                        };
                      }
                      input.click();
                    },
                  }}
                  onEditorChange={(content) => {
                    // setEditorText(content);
                  }}
                />
                </div>
                </div>
              </div>
            </div>
          </form>
        </>
      </div>
    </Col>
  );
};

export default CreateEditHighlight;
